<!-- =========================================================================================
  File Name: ItemGridView.vue
  Description: Item Component - Grid VIew
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
	<!-- <div class="item-grid-view vx-row match-height">
        <div class="vx-col" :class="gridColumnWidth" v-for="item in items" :key="item.objectID"> -->
	<vx-card class="grid-view-item mb-base overflow-hidden" v-on="$listeners">
		<template slot="no-body">
			<b-row style="height: 100%">
				<b-col cols="12">
					<b-row class="
              item-img-container
              bg-white
              flex
              d-flex
              items-center
              justify-center
              mb-4
              cursor-pointer
            " @click="navigate_to_detail_view">
						<!--     <v-zoomer
          style="width: 500px; height: 500px; border: solid 1px silver"
          doubleClickToZoom
        >
          <img
            :src="sistemurl + item.image"
            style="object-fit: contain; width: 100%; height: 100%"
          />
           @click="navigate_to_detail_view"
        </v-zoomer>-->
						<img v-if="item.image" :src="sistemurl + item.image" :alt="item.stockName" class="grid-view-img px-4" @error="errorImage"/>
					</b-row>
				</b-col>
				<b-col cols="12">
					<b-row style="margin: 15px" class="
              bg-white
              flex
              items-center
              justify-center
              mb-4
              text-center
              cursor-pointer
            " @click="findScroll">
						<a :href="webUrl + '/products/item/' + (isVariant == 'false' ? item.barcode : item.stockCode)"
							rel="noreferrer">
							<h6 class="mb-2">{{ item.stockName }}</h6>
						</a>
						<a :href="webUrl + '/products/item/' + (isVariant == 'false' ? item.barcode : item.stockCode)"
							rel="noreferrer">
							<h6 class="mb-2">{{ item.stockCode }}</h6>
						</a>
					</b-row>
				</b-col>
				<b-col cols="12">
					<b-row class="item-details px-4" style="text-align: center; margin-bottom: 25px">
						<!-- RATING & PRICE -->

						<!-- TITLE & DESCRIPTION

        <p
          style="margin: 0px !important"
          class="item-description truncate text-sm"
        >
          <span class="font-bold">RENK:</span>
          {{ productColor }}
        </p>
        <p
          style="margin: 0px !important"
          class="item-description truncate text-sm"
        >
          <span class="font-bold">EBAT:</span>
          {{ productSize }}
        </p>
        <p
          style="margin: 0px !important"
          class="item-description truncate text-sm"
        >
          <span class="font-bold">PAKET İÇERİĞİ:</span>
          {{ productCount }} adet
        </p>
 -->
					</b-row>
				</b-col>
				<b-col align-self="end">
					<h6 style="margin-top: 15px; text-align: center" class="font-bold" v-if="musteriTanim == false">
						{{ floatPrice.toFixed(2) }} TL
					</h6>
					<h6 style="margin-top: 15px; text-align: center" class="font-bold" v-else>
						0 TL
					</h6>
					<slot name="action-buttons" />
				</b-col>
			</b-row>
			<!-- ITEM IMAGE -->

			<!-- SLOT: ACTION BUTTONS -->
		</template>
	</vx-card>
	<!--  </div>
    </div> -->
</template>

<script>
import Store from "../../../../store/store";
import state from "../../../../store/state";
import VueZoomer from "vue-zoomer";
import userJson from "../../../../../public/user.json";
export default {
	components: {
		VZoomer: VueZoomer.Zoomer,
		VZoomerGallery: VueZoomer.Gallery
	},
	data() {
		return {
			musteriTanim: false,
			sistemurl: "",

			productPrice: 0.0,
			productColor: "",
			productSize: "",
			productCount: 0,
			floatPrice: 0.0,
			webUrl: userJson.url,
			isVariant: userJson.varyant
		};
	},
	props: {
		item: {
			type: Object,
			required: true
		}
	},
	methods: {
		errorImage(e){   
      if(e.type == "error") e.target.src = "https://int.kamyonyedekparca.com/img/404picture.jpg" 
    },
		findScroll() {
			localStorage.setItem("UPDATE_WINDOW_SCROLL_PRODUCT_Y", window.scrollY);
		},
		productDetailsParse() {
			try {
				var vm = this;

				if (typeof vm.item.price == "object") {
					vm.priceParseList = JSON.parse(vm.item.price);
					vm.productPrice = vm.priceParseList[0].fiyat;
				} else {
					vm.productPrice = vm.item.price;
					vm.floatPrice = parseFloat(vm.productPrice);
				}

				if (typeof vm.item.defaultCategoryPath == "object") {
					vm.detailsList = JSON.parse(vm.item.defaultCategoryPath);

					vm.productColor = vm.detailsList[0].altKategori;
					vm.productSize = vm.detailsList[0].altKategori1;
					vm.productCount = vm.detailsList[0].paketAdet;
				} else {
					// vm.productColor = vm.item.
					// vm.productSize =
					// vm.productCount =
				}

				vm.trimDetails = vm.item.details;
			} catch (error) {
			}
		},
		navigate_to_detail_view() {
			// alert(this.item);
			//  alert(this.item.barcode);
			if (userJson.varyant == "true") {
				this.$router
					.push({
						name: "ecommerce-item-detail-view",
						params: { item_id: this.item.stockCode }
					})
					.catch(() => { });
			} else {
				this.$router
					.push({
						name: "ecommerce-item-detail-view",
						params: { item_id: this.item.barcode }
					})
					.catch(() => { });
			}
		}
	},
	created() {
 

		this.sistemurl = userJson.resimUrl;
 
		this.productDetailsParse();
	}
};
</script>

<style lang="scss" scoped>
.grid-view-item {
	.grid-view-img {
		max-width: 100%;
		max-height: 100%;
		width: auto;
		transition: 0.35s;
	}

	&:hover {
		transform: translateY(-5px);
		box-shadow: 0px 4px 25px 0px rgba(0, 0, 0, 0.25);

		.grid-view-img {
			opacity: 0.9;
		}
	}
}
</style>
